/**
 * Palette de data-visualisation (validée daltonisme). Couleurs par rôle, pas par
 * rang : chaque macronutriment a un slot fixe. Jeux light/dark, choisis par thème.
 */
export interface ChartColors {
  surface: string;
  grid: string;
  textPrimary: string;
  textSecondary: string;
  // Slots catégoriels (ordre fixe = sécurité daltonisme)
  blue: string;
  aqua: string;
  yellow: string;
  green: string;
  violet: string;
  red: string;
  magenta: string;
  orange: string;
  // Statuts réservés
  good: string;
  critical: string;
  warning: string;
}

export const LIGHT: ChartColors = {
  surface: '#fcfcfb',
  grid: '#e8e7e3',
  textPrimary: '#0b0b0b',
  textSecondary: '#52514e',
  blue: '#2a78d6',
  aqua: '#1baf7a',
  yellow: '#eda100',
  green: '#008300',
  violet: '#4a3aa7',
  red: '#e34948',
  magenta: '#e87ba4',
  orange: '#eb6834',
  good: '#0ca30c',
  critical: '#d03b3b',
  warning: '#fab219',
};

export const DARK: ChartColors = {
  surface: '#1a1a19',
  grid: '#33322f',
  textPrimary: '#ffffff',
  textSecondary: '#c3c2b7',
  blue: '#3987e5',
  aqua: '#199e70',
  yellow: '#c98500',
  green: '#008300',
  violet: '#9085e9',
  red: '#e66767',
  magenta: '#d55181',
  orange: '#d95926',
  good: '#0ca30c',
  critical: '#d03b3b',
  warning: '#fab219',
};

/** Affectation stable macronutriment → slot couleur (suit le nutriment, jamais le rang). */
export const MACRO_ROLE = {
  protein: 'aqua',
  carbs: 'yellow',
  fat: 'orange',
  saturated: 'red',
  fiber: 'green',
  sugars: 'magenta',
} as const satisfies Record<string, keyof ChartColors>;
